export default __webpack_public_path__ + "static/media/section5-pic1.ae9c62ad.png";